// Firebase Realtime Database path segments can't contain . # $ [ ] / — any of
// those in a user-supplied string (a category name, a series key) must be
// sanitized before use as a key, consistently on both the write and read side.
export const firebaseSafeKey = (k) => String(k).replace(/[.#$[\]/]/g, '_');
